import LoginForm from "@/features/authentication/login/LoginForm";

function Login() {
  return (
    <>
      <main className="mx-auto">
        <LoginForm />
      </main>
    </>
  );
}

export default Login;
